var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,256A128,128,0,1,1,256,128v.39A128,128,0,0,1,128,256Zm-.16-10c65,.05,118.09-52.88,118.15-117.83S193.12,10.07,128.17,10,10.07,62.89,10,127.84,62.91,245.94,127.85,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.76,231c-53.53-.1-97.82-41-102.49-94.72-4.53-52,31.94-99.76,83.58-109.43,24.17-4.53,47-.71,68.66,10.79,1.32.71,2.6,1.5,3.88,2.27,3,1.8,4.4,4.32,2.36,7.49-1.88,2.9-4.5,2.49-7.47,1.17-8.49-3.75-16.82-8.3-25.71-10.62-53.79-14.08-108,23.18-114.74,78.43-6.11,50,28.26,95.94,77.35,103.45,50.6,7.74,97.66-25.59,106.53-75.75,3.81-21.57.17-42.08-10.45-61.3-.56-1-1.15-2-1.74-3-1.78-3-1.83-5.84,1.47-7.7,3.09-1.75,5.73-.37,7,2.55,4.09,9.24,9.12,18.3,11.63,28C244.53,167.8,195.05,231.14,127.76,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.19,127.38V99.43c0-6.47,2.15-11.8,8-15s11.46-2.34,16.94,1.21c14.67,9.47,29.45,18.77,44.08,28.31,10.87,7.09,10.88,19.9,0,27-14.75,9.64-29.68,19-44.52,28.54-5.36,3.44-10.91,4-16.51.88s-8-8.2-8-14.53C95.21,146.36,95.19,136.87,95.19,127.38Zm16,35a19.62,19.62,0,0,0,3.19-1.39c14.87-9.48,29.74-19,44.53-28.56,4.57-3,4.59-7,0-9.93q-22.38-14.55-45-28.78c-4.42-2.77-8.35-.53-8.64,4.72-.21,3.82,0,7.66,0,11.49v45.45c0,3.74,1.1,6.49,5.88,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,59.58c-1.86,1.38-3.87,4-5.56,3.81-1.86-.2-4.35-2.78-4.79-4.73-.28-1.21,2.61-4.27,4.32-4.48s3.95,1.92,5.95,3Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo2);
export default __webpack_public_path__ + "static/media/video2.7730829c03903dfc6d8c662d920cc54e.svg";
export { ForwardRef as ReactComponent };